// @flow

import React from 'react';
import { Text, ErrorIcon, TickCircleIcon } from 'seek-style-guide/react';
import findKey from 'lodash/findKey';
import styles from './StatusMessage.less';

type Props = {
  children: any,
  positive?: boolean,
  critical?: boolean,
  standard?: boolean,
  className?: string,
  dataAutomation?: string
};

export default ({
  children: message,
  dataAutomation: dataProp,
  standard,
  className,
  ...textStyle
}: Props) => {
  const Icon = textStyle.positive ? TickCircleIcon : ErrorIcon;
  const messageTypeKey = findKey(textStyle, value => value) || '';

  const dataAutomation = dataProp
    ? dataProp
    : `${messageTypeKey}-form-status-message`;

  return (
    <Text
      small={!standard}
      {...textStyle}
      data-automation={dataAutomation}
      className={className}
    >
      <Icon className={styles.icon} filled />
      {message}
    </Text>
  );
};
